import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { message } from "antd";
import { Log, logType, tokenHandle } from "../../../constant/helper";
import { ApiUrl, baseUrl } from "../../../constant/Api";

export default function LinkedinInPopup() {
  const { search } = useLocation();

  const params = new URLSearchParams(search);

  useEffect(() => {
    const code = params.get("code");

    axios
      .get(baseUrl + ApiUrl.register.linkedin + code, {
        headers: {
          Accept: "application/json",
          lang: "fa",
        },
      })
      .then((resp) => {
        sessionStorage.setItem("phone", resp.data.username);
        sessionStorage.setItem("code", code);

        message.success("شما با موفقیت وارد شدید");

        tokenHandle()
          .then((r) => Log(r))
          .catch((e) => Log(e));
      })
      .catch((err) => {
        Log(err, logType.error);
        if (err.response && err.response.data && err.response.data.message) {
          const { message: text } = err.response.data;
          message.error(text);
        } else {
          message.error("خطا در ارسال اطلاعات");
        }
      });
    // eslint-disable-next-line
  }, [search]);

  return <></>;
}
